import IsMobile from "../IsMobile";
import NewsPanel from "../SegmentSubComponents/NewsPanel"
import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../Redux Store/reducers";
import NewsPostDisplay from "../SegmentSubComponents/NewsPostDisplay";
import HomeBannerPanel from "../SegmentSubComponents/HomeBannerPanel";
import { FaYoutube, FaItchIo, FaEnvelope, FaDiscord, FaSteam, FaGithub, FaTiktok, FaTwitter, FaBandcamp, FaSoundcloud } from "react-icons/fa";
import { SiBluesky } from "react-icons/si";
import { AiFillInstagram } from "react-icons/ai";


const HomeHtmlText = (): React.JSX.Element => {
    const SOCIAL_ICON_SIZE = "60px";

    return <div>
        <p>
            This website is a work in progress.
        </p>

        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center", gap: "30px" }}>
            <a
                className="App-link"
                href="https://blawnode.itch.io/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", flexDirection: "column", alignItems: "center", textDecoration: "none" }}
            >
                <FaItchIo style={{ width: SOCIAL_ICON_SIZE, height: SOCIAL_ICON_SIZE, color: "#FA5C5C", marginBottom: "10px" }} />
                <div style={{ textAlign: "center", fontSize: "small" }}>
                    blawnode.itch.io<br />
                    (Games!)
                </div>
            </a>

            <a
                className="App-link"
                href="https://www.youtube.com/@blawnode"
                // Can you put code in other lines?
                // Yes, for example, you can add imports at the top of the file.
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", flexDirection: "column", alignItems: "center", textDecoration: "none" }}>
                <FaYoutube style={{ width: SOCIAL_ICON_SIZE, height: SOCIAL_ICON_SIZE, color: "#FF0000", marginBottom: "10px" }} />
                <div style={{ textAlign: "center", fontSize: "small" }}>
                    My YouTube Channel<br />
                    (Music! ♪)
                </div>
            </a>
        </div>

        <br/>

        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-start", gap: "20px", flexWrap: "wrap" }}>
            {/* Active Socials */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                <div style={{ fontSize: "0.6em", fontWeight: "bold" }}>Active</div>
                <div style={{ display: "flex", flexDirection: "row", gap: "15px", flexWrap: "wrap", justifyContent: "center" }}>
                    <a href="https://bsky.app/profile/blawnode.bsky.social" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <SiBluesky size={24} color="#0085ff" />
                    </a>
                    <a href="mailto:blawnode@gmail.com" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaEnvelope size={24} color="#EA4335" />
                    </a>
                </div>
            </div>

            {/* Vertical divider */}
            <div style={{ width: "1px", backgroundColor: "#ccc", height: "40px", alignSelf: "center" }}></div>

            {/* Inactive Socials */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                <div style={{ fontSize: "0.6em", fontWeight: "bold" }}>Inactive</div>
                <div style={{ display: "flex", flexDirection: "row", gap: "15px", flexWrap: "wrap", justifyContent: "center" }}>
                    <a href="" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaDiscord size={24} color="#5865F2" />
                    </a>
                    <a href="https://store.steampowered.com/curator/45211893" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaSteam size={24} color="#1b2838" />
                    </a>
                    <a href="https://github.com/blawnode/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaGithub size={24} color="#181717" />
                    </a>
                    <a href="https://blawnode.bandcamp.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaBandcamp size={24} color="#629aa0" />
                    </a>
                    <a href="https://soundcloud.com/blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaSoundcloud size={24} color="#FF5500" />
                    </a>
                    <a href="https://www.tiktok.com/@blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaTiktok size={24} color="#000000" />
                    </a>
                    <a href="https://www.instagram.com/blawnode/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <AiFillInstagram size={24} color="#E4405F" />
                    </a>
                    <a href="https://x.com/blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <FaTwitter size={24} color="#1DA1F2" />
                    </a>
                </div>
            </div>
        </div>

        {/*<br/>

        <p style={{fontSize: "0.8em"}}>
            Additional text.
        </p>*/}
    </div>
}


const HomeSegment_NonMobile = () => {
    const selectedPost = useSelector((state: RootState) => state.selectedPost);  // Accessing the data from Redux store

    const contentPanelStyle = {
        width: "60%", height: "70%",
        display: "flex", flexDirection: "column", alignItems: "flex-start",
        ...((selectedPost == null) ? {} : {textAlign: "left", overflow: "scroll",})
    };
    const contentPanelStyle2 = {
        ...{width: "60%", height: "70%",
        display: "flex", flexDirection: "column", alignItems: "flex-start",},
        ...((selectedPost == null) ? {} : {})
        //textAlign: "left",
        //overflow: "scroll",
    };

    return <div id="home-segment"
                style={{
                    width: "80vw", height: "87.5vh",
                }}>
        <div id="HomeBannerPanel-container" style={{
            width: "inherit", height: "20%",
            display: "flex", justifyContent: "center", alignItems: "center",}}>
            <HomeBannerPanel/>
        </div>
        <div style={{
            width: "inherit", height: "80%",
            display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center",
        }}>
            <div id="news-container"
            style={{
            width: "32.5%", height: "80%",
            display: "flex", alignItems: "center",
        }}>
            <NewsPanel/>
        </div>

        <div style={{
            width: "57.5%",
            display: "flex", flexDirection: "column", alignItems: "flex-start",
            textAlign: "left",
            ...((selectedPost == null) ? {} : {height: "70%", overflow: "auto", overflowWrap: "anywhere",})
        }}>
            {/*{selectedPost == null ? <HomeHtmlText/> : JSON.stringify(selectedPost)}*/}
            {selectedPost == null ? <HomeHtmlText/> : <NewsPostDisplay postData={selectedPost}/>}
        </div>

        {/*<div id="blanks" style={{
            width: "10%",
        }}>
        </div>*/}
        </div>
    </div>;
}

const HomeSegment_Mobile = () => {
    const selectedPost = useSelector((state: RootState) => state.selectedPost); // Accessing the data from Redux store
    
    var childHeightsCombined = "" + (20 + 20 + 20 + 95) + "vh";

    return <div id="home-segment"
                style={{
                    width: "80vw", maxHeight: childHeightsCombined,
                    marginTop: "5vh", gap: "5vh",
                    display: "flex", flexDirection: "column", alignItems: "center",
                }}>
        <div id="HomeBannerPanel-container" style={{
            width: "inherit", height: "12.5vh", maxHeight: "10%",
            display: "flex", justifyContent: "center", alignItems: "center",}}>
            <HomeBannerPanel/>
        </div>
        <div style={{
            width: "100%", height: "20vh",
            display: "flex", flexDirection: "column", alignItems: "center",
        }}>
            <NewsPanel/>
        </div>

        {/*<div style={{width: "inherit", height: "20vh", display: "flex", justifyContent: "center", alignItems: "center",}}>
            <h1>TODO: Works in Progress Banner</h1>
        </div>*/}

        {/* // TODO: Why 95? Why maxHeight? */}
        <div style={{
            maxHeight: "95vh",
            display: "flex", flexDirection: "column", alignItems: "flex-start",
            textAlign: "left",
        }}>
            {selectedPost == null ? <HomeHtmlText/> : <NewsPostDisplay postData={selectedPost}/>}
        </div>

        {/*<div id="blanks" style={{
            width: "10%",
        }}>
        </div>*/}
    </div>;
}

const HomeSegment = () => {
    return IsMobile() ? <HomeSegment_Mobile/> : <HomeSegment_NonMobile/>;
};

export default HomeSegment;